<template>
  <div data-nosnippet>
    <div v-for="topBar in topBars" :key="topBar.id" class="saas-top-bar">
      <i
        v-if="topBar.icon"
        :class="`saas-top-bar__icon iconoir-${topBar.icon}`"
      ></i>
      {{ topBar.text }}
      <a
        v-if="topBar.link_name && topBar.link_url"
        :href="topBar.link_url"
        class="saas-top-bar__link"
        :rel="topBar.link_url.charAt(0) !== '/' ? 'noopener noreferrer' : ''"
        >{{ topBar.link_name }}</a
      >
    </div>
    <nav v-show="navOpen" class="saas-menu">
      <div class="saas-menu__head">
        <NuxtLink :to="{ name: 'index' }" class="saas-menu__Logo">
          <img
            class="placeholder__logo-image"
            src="@baserow/modules/core/static/img/logo.svg?url"
            alt="Baserow logo"
            data-allow-mismatch
          />
        </NuxtLink>
        <div>
          <a class="saas-menu__close" @click="hideNav()">
            <i class="iconoir-cancel"></i>
          </a>
        </div>
      </div>
      <ul class="saas-menu__items">
        <li
          v-for="productPath in productPages"
          :key="productPath.path"
          class="saas-menu__item"
        >
          <NuxtLink :to="productPath.path" class="saas-menu__link">{{
            productPath.title
          }}</NuxtLink>
        </li>
        <li v-if="departmentPages.length > 0" class="saas-menu__item">
          <a
            class="saas-menu__link"
            @click="toggleMenuSub($event, $refs.departmentMenu)"
          >
            Solutions by department
            <i
              class="saas-menu__icon"
              :class="
                inMenuSub($refs.departmentMenu)
                  ? 'iconoir-nav-arrow-down'
                  : 'iconoir-nav-arrow-right'
              "
            ></i>
          </a>
          <ul
            ref="departmentMenu"
            class="saas-menu__items-sub"
            :class="{ hidden: !inMenuSub($refs.departmentMenu) }"
          >
            <li
              v-for="departmentPage in departmentPages"
              :key="departmentPage.path"
            >
              <NuxtLink :to="departmentPage.path">{{
                departmentPage.title
              }}</NuxtLink>
            </li>
          </ul>
        </li>
        <li v-if="industryPages.length > 0" class="saas-menu__item">
          <a
            class="saas-menu__link"
            @click="toggleMenuSub($event, $refs.industryMenu)"
          >
            Solutions by industry
            <i
              class="saas-menu__icon"
              :class="
                inMenuSub($refs.industryMenu)
                  ? 'iconoir-nav-arrow-down'
                  : 'iconoir-nav-arrow-right'
              "
            ></i>
          </a>
          <ul
            ref="industryMenu"
            class="saas-menu__items-sub"
            :class="{ hidden: !inMenuSub($refs.industryMenu) }"
          >
            <li v-for="industryPage in industryPages" :key="industryPage.path">
              <NuxtLink :to="industryPage.path">{{
                industryPage.title
              }}</NuxtLink>
            </li>
          </ul>
        </li>
        <li class="saas-menu__item">
          <NuxtLink :to="{ name: 'pricing' }" class="saas-menu__link"
            >Pricing</NuxtLink
          >
        </li>
        <li class="saas-menu__item">
          <a
            class="saas-menu__link"
            @click="toggleMenuSub($event, $refs.communityMenu)"
          >
            Community
            <i
              class="saas-menu__icon"
              :class="
                inMenuSub($refs.communityMenu)
                  ? 'iconoir-nav-arrow-down'
                  : 'iconoir-nav-arrow-right'
              "
            ></i>
          </a>
          <ul
            ref="communityMenu"
            class="saas-menu__items-sub"
            :class="{ hidden: !inMenuSub($refs.communityMenu) }"
          >
            <li
              v-for="communityPage in communityPages"
              :key="communityPage.path"
            >
              <NuxtLink :to="communityPage.path">Get started</NuxtLink>
            </li>
            <li>
              <a href="https://community.baserow.io/" target="_blank"
                >Find answers</a
              >
            </li>
            <li>
              <a
                href="https://community.baserow.io/c/tips-and-tricks/16"
                target="_blank"
                >Tips and tricksssssss</a
              >
            </li>
            <li>
              <a
                href="https://community.baserow.io/c/made-with-baserow/14"
                target="_blank"
                >#MadeWithBaserow</a
              >
            </li>
          </ul>
        </li>
        <li class="saas-menu__item">
          <a
            class="saas-menu__link"
            @click="toggleMenuSub($event, $refs.developersMenu)"
          >
            Developers
            <i
              class="saas-menu__icon"
              :class="
                inMenuSub($refs.developersMenu)
                  ? 'iconoir-nav-arrow-down'
                  : 'iconoir-nav-arrow-right'
              "
            ></i>
          </a>
          <ul
            ref="developersMenu"
            class="saas-menu__items-sub"
            :class="{ hidden: !inMenuSub($refs.developersMenu) }"
          >
            <li>
              <NuxtLink
                :to="{
                  name: 'dev-docs',
                  params: {
                    path: 'index',
                  },
                }"
                >Getting started</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                :to="{
                  name: 'dev-docs',
                  params: { path: 'plugins/introduction' },
                }"
                >Creating a plugin</NuxtLink
              >
            </li>
            <li>
              <NuxtLink :to="{ name: 'database-api-docs' }">API</NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="{
                  name: 'dev-docs',
                  params: { path: 'installation/install-with-docker' },
                }"
                >Install with Docker</NuxtLink
              >
            </li>
            <li>
              <a :href="publicBackendUrl + '/api/redoc/'" target="_blank"
                >OpenAPI specification</a
              >
            </li>
            <li>
              <a
                href="https://github.com/baserow/baserow"
                rel="noopener noreferrer"
                target="_blank"
                >GitHub repository</a
              >
            </li>
            <li>
              <NuxtLink
                :to="{
                  name: 'dev-docs',
                  params: { path: 'development/development-environment' },
                }"
                >Want to contribute?</NuxtLink
              >
            </li>
          </ul>
        </li>
        <li class="saas-menu__item">
          <a
            class="saas-menu__link"
            @click="toggleMenuSub($event, $refs.resourcesMenu)"
          >
            Resources
            <i
              class="saas-menu__icon"
              :class="
                inMenuSub($refs.resourcesMenu)
                  ? 'iconoir-nav-arrow-down'
                  : 'iconoir-nav-arrow-right'
              "
            ></i>
          </a>
          <ul
            ref="resourcesMenu"
            class="saas-menu__items-sub"
            :class="{ hidden: !inMenuSub($refs.resourcesMenu) }"
          >
            <li>
              <NuxtLink :to="{ name: 'blog' }">Blog</NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="{
                  name: 'blog-filtered',
                  params: { category: 'tutorials' },
                }"
                >Tutorials</NuxtLink
              >
            </li>
            <li>
              <NuxtLink :to="{ name: 'videos' }">Videos</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="{ name: 'user-docs' }">Knowledge base</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="{ name: 'templates' }">Templates</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="{ name: 'academy' }">Academy</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="{ name: 'about-us' }">About us</NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="{
                  name: 'blog-filtered',
                  params: { category: 'customer-stories' },
                }"
                >Customer Stories</NuxtLink
              >
            </li>
            <li>
              <NuxtLink :to="{ name: 'contact' }">Contact us</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="{ name: 'faq' }">FAQ</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="{ name: 'partners' }">Partners</NuxtLink>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="saas-menu__items">
        <li class="saas-menu__item">
          <NuxtLink :to="{ name: 'contact-sales' }" class="saas-menu__link"
            >Contact sales</NuxtLink
          >
        </li>

        <li v-if="!isAuthenticated" class="saas-menu__item">
          <Button :to="{ name: 'login' }" type="secondary" size="large"
            >Login</Button
          >
        </li>
        <li v-if="!isAuthenticated" class="saas-menu__item">
          <Button :to="{ name: 'signup' }" size="large">Sign up</Button>
        </li>
        <li v-if="isAuthenticated" class="saas-menu__item">
          <Button :to="{ name: 'all-workspaces' }" type="secondary" size="large"
            >My dashboard</Button
          >
        </li>

        <li class="saas-menu__item">
          <GithubStarButton></GithubStarButton>
        </li>
      </ul>
    </nav>
    <header class="saas-header">
      <div class="saas-header__logo">
        <NuxtLink :to="{ name: 'index' }">
          <img
            class="saas-header__logo-image"
            src="@baserow/modules/core/static/img/logo.svg?url"
            alt="Baserow logo"
            height="29"
            data-allow-mismatch
          />
        </NuxtLink>
      </div>
      <nav class="saas-header__nav">
        <ul class="saas-header__nav-list">
          <li class="saas-header__nav-item">
            <a
              class="saas-header__nav-link"
              :class="{
                'saas-header__nav-link--open': openSub === $refs.productSub,
              }"
              @click="toggleSub($event, $refs.productSub)"
            >
              Platform
              <i class="saas-header__nav-link-more iconoir-nav-arrow-down"></i>
            </a>
            <div
              ref="productSub"
              class="saas-header__sub"
              :class="{
                'saas-header__sub--open': openSub === $refs.productSub,
              }"
            >
              <div class="saas-header__sub-section">
                <div
                  class="saas-header__sub-title saas-header__sub-title--indent"
                >
                  Discover Baserow
                </div>
                <div class="saas-header__sub-navs">
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      v-for="productPage in productPagesTwoChunks[0]"
                      :key="productPage.path"
                      :icon="productPage.icon_class_name || 'iconoir-building'"
                      :title="productPage.title"
                      :description="productPage.navigation_description || ''"
                      :to="productPage.path"
                    ></HeaderSubNavItem>
                  </ul>
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      v-for="productPage in productPagesTwoChunks[1]"
                      :key="productPage.path"
                      :icon="productPage.icon_class_name || 'iconoir-building'"
                      :title="productPage.title"
                      :description="productPage.navigation_description || ''"
                      :to="productPage.path"
                    ></HeaderSubNavItem>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="saas-header__nav-item">
            <a
              class="saas-header__nav-link"
              :class="{
                'saas-header__nav-link--open': openSub === $refs.solutionsSub,
              }"
              @click="toggleSub($event, $refs.solutionsSub)"
            >
              Solutions
              <i class="saas-header__nav-link-more iconoir-nav-arrow-down"></i>
            </a>
            <div
              ref="solutionsSub"
              class="saas-header__sub"
              :class="{
                'saas-header__sub--open': openSub === $refs.solutionsSub,
              }"
            >
              <div
                v-if="departmentPages.length > 0"
                class="saas-header__sub-section"
              >
                <div
                  class="saas-header__sub-title saas-header__sub-title--indent"
                >
                  Departments
                </div>
                <div class="saas-header__sub-navs">
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      v-for="departmentPage in departmentPagesTwoChunks[0]"
                      :key="departmentPage.path"
                      :icon="
                        departmentPage.icon_class_name || 'iconoir-building'
                      "
                      :title="departmentPage.title"
                      :to="departmentPage.path"
                    ></HeaderSubNavItem>
                  </ul>
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      v-for="departmentPage in departmentPagesTwoChunks[1]"
                      :key="departmentPage.path"
                      :icon="
                        departmentPage.icon_class_name || 'iconoir-building'
                      "
                      :title="departmentPage.title"
                      :to="departmentPage.path"
                    ></HeaderSubNavItem>
                  </ul>
                </div>
              </div>
              <div
                v-if="industryPages.length > 0"
                class="saas-header__sub-section"
              >
                <div
                  class="saas-header__sub-title saas-header__sub-title--indent"
                >
                  Industries
                </div>
                <div class="saas-header__sub-navs">
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      v-for="industryPage in industryPagesTwoChunks[0]"
                      :key="industryPage.path"
                      :icon="industryPage.icon_class_name || 'iconoir-building'"
                      :title="industryPage.title"
                      :to="industryPage.path"
                    ></HeaderSubNavItem>
                  </ul>
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      v-for="industryPage in industryPagesTwoChunks[1]"
                      :key="industryPage.path"
                      :icon="industryPage.icon_class_name || 'iconoir-building'"
                      :title="industryPage.title"
                      :to="industryPage.path"
                    ></HeaderSubNavItem>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="saas-header__nav-item">
            <NuxtLink :to="{ name: 'pricing' }" class="saas-header__nav-link"
              >Pricing</NuxtLink
            >
          </li>
          <li class="saas-header__nav-item">
            <a
              class="saas-header__nav-link"
              :class="{
                'saas-header__nav-link--open': openSub === $refs.communitySub,
              }"
              @click="toggleSub($event, $refs.communitySub)"
            >
              Community
              <i class="saas-header__nav-link-more iconoir-nav-arrow-down"></i>
            </a>
            <div
              ref="communitySub"
              class="saas-header__sub"
              :class="{
                'saas-header__sub--open': openSub === $refs.communitySub,
              }"
            >
              <div class="saas-header__sub-section">
                <div class="saas-header__sub-navs">
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      v-for="communityPage in communityPages"
                      :key="communityPage.path"
                      icon="iconoir-group"
                      title="Get started"
                      description="Discover what the Baserow community is created for"
                      :to="communityPage.path"
                    ></HeaderSubNavItem>
                    <HeaderSubNavItem
                      icon="iconoir-chat-bubble-question"
                      title="Find answers"
                      description="Ask questions and get the most out of the platform"
                      href="https://community.baserow.io/"
                      target="_blank"
                    ></HeaderSubNavItem>
                    <HeaderSubNavItem
                      icon="iconoir-puzzle"
                      title="Partners"
                      description="Team up with our partners for various services."
                      :to="{ name: 'partners' }"
                      target="_blank"
                    ></HeaderSubNavItem>
                  </ul>
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      icon="iconoir-open-book"
                      title="Tips and tricks"
                      description="Take your data management expertise to the next level"
                      href="https://community.baserow.io/c/tips-and-tricks/16"
                      target="_blank"
                    ></HeaderSubNavItem>
                    <HeaderSubNavItem
                      icon="iconoir-light-bulb-on"
                      title="#MadeWithBaserow"
                      description="Get inspired by the projects from our community"
                      href="https://community.baserow.io/c/made-with-baserow/14"
                      target="_blank"
                    ></HeaderSubNavItem>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="saas-header__nav-item">
            <a
              class="saas-header__nav-link"
              :class="{
                'saas-header__nav-link--open': openSub === $refs.developersSub,
              }"
              @click="toggleSub($event, $refs.developersSub)"
            >
              Developers
              <i class="saas-header__nav-link-more iconoir-nav-arrow-down"></i>
            </a>
            <div
              ref="developersSub"
              class="saas-header__sub saas-header__sub--align-middle"
              :class="{
                'saas-header__sub--open': openSub === $refs.developersSub,
              }"
            >
              <div class="saas-header__sub-section">
                <div class="saas-header__sub-navs">
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      icon="iconoir-book"
                      title="Getting started"
                      :to="{
                        name: 'dev-docs',
                        params: {
                          path: 'index',
                        },
                      }"
                    ></HeaderSubNavItem>
                    <HeaderSubNavItem
                      icon="iconoir-ev-plug"
                      title="Creating a plugin"
                      :to="{
                        name: 'dev-docs',
                        params: { path: 'plugins/introduction' },
                      }"
                    ></HeaderSubNavItem>
                    <HeaderSubNavItem
                      icon="iconoir-server"
                      title="API"
                      :to="{ name: 'database-api-docs' }"
                    ></HeaderSubNavItem>
                  </ul>
                  <ul class="saas-header__sub-nav">
                    <HeaderSubNavItem
                      icon="iconoir-download"
                      title="Install with Docker"
                      :to="{
                        name: 'dev-docs',
                        params: { path: 'installation/install-with-docker' },
                      }"
                    ></HeaderSubNavItem>
                    <HeaderSubNavItem
                      icon="iconoir-arrow-right"
                      title="OpenAPI specification"
                      :href="publicBackendUrl + '/api/redoc/'"
                      target="_blank"
                    ></HeaderSubNavItem>
                  </ul>
                </div>
              </div>
              <div class="saas-header__sub-section">
                <ul class="saas-header__sub-nav">
                  <HeaderSubNavItem
                    icon="iconoir-github"
                    title="GitHub repository"
                    href="https://github.com/baserow/baserow"
                    rel="noopener noreferrer"
                    target="_blank"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-plus"
                    title="Want to contribute?"
                    :to="{
                      name: 'dev-docs',
                      params: { path: 'development/development-environment' },
                    }"
                  ></HeaderSubNavItem>
                </ul>
              </div>
            </div>
          </li>
          <li class="saas-header__nav-item">
            <a
              class="saas-header__nav-link"
              :class="{
                'saas-header__nav-link--open': openSub === $refs.resourcesSub,
              }"
              @click="toggleSub($event, $refs.resourcesSub)"
            >
              Resources
              <i class="saas-header__nav-link-more iconoir-nav-arrow-down"></i>
            </a>
            <div
              ref="resourcesSub"
              class="saas-header__sub saas-header__sub--align-right"
              :class="{
                'saas-header__sub--open': openSub === $refs.resourcesSub,
              }"
            >
              <div class="saas-header__sub-section">
                <div
                  class="saas-header__sub-title saas-header__sub-title--indent"
                >
                  Learn
                </div>
                <ul class="saas-header__sub-nav">
                  <HeaderSubNavItem
                    icon="iconoir-megaphone"
                    title="Blog"
                    :to="{ name: 'blog' }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-book"
                    title="Tutorials"
                    :to="{
                      name: 'blog-filtered',
                      params: { category: 'tutorials' },
                    }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-video-camera"
                    title="Videos"
                    :to="{
                      name: 'videos',
                    }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-binocular"
                    title="Knowledge base"
                    :to="{ name: 'user-docs' }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-graduation-cap"
                    title="Academy"
                    :to="{ name: 'academy' }"
                  ></HeaderSubNavItem>
                </ul>
              </div>
              <div class="saas-header__sub-section">
                <div
                  class="saas-header__sub-title saas-header__sub-title--indent"
                >
                  Inspiration
                </div>
                <ul class="saas-header__sub-nav">
                  <HeaderSubNavItem
                    icon="iconoir-box"
                    title="Templates"
                    :to="{ name: 'templates' }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-medal"
                    title="About us"
                    :to="{ name: 'about-us' }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    v-for="integrationPage in integrationPages"
                    :key="integrationPage.path"
                    icon="iconoir-building"
                    title="Integrations"
                    :to="integrationPage.path"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-chat-bubble"
                    title="Customer Stories"
                    :to="{
                      name: 'blog-filtered',
                      params: { category: 'customer-stories' },
                    }"
                  ></HeaderSubNavItem>
                </ul>
              </div>
              <div class="saas-header__sub-section">
                <div
                  class="saas-header__sub-title saas-header__sub-title--indent"
                >
                  Support
                </div>
                <ul class="saas-header__sub-nav">
                  <HeaderSubNavItem
                    icon="iconoir-message-text"
                    title="Contact us"
                    :to="{ name: 'contact' }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-warning-circle"
                    title="FAQ"
                    :to="{ name: 'faq' }"
                  ></HeaderSubNavItem>
                  <HeaderSubNavItem
                    icon="iconoir-puzzle"
                    title="Partners"
                    :to="{ name: 'partners' }"
                  ></HeaderSubNavItem>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </nav>
      <nav class="saas-header__nav saas-header__nav--last">
        <ul class="saas-header__nav-list">
          <li class="saas-header__nav-item saas-header__nav-item--spacer">
            <GithubStarButton :in-header="true"></GithubStarButton>
          </li>
          <li class="saas-header__nav-item margin-right-2">
            <NuxtLink
              :to="{ name: 'contact-sales' }"
              class="saas-header__nav-link"
            >
              Contact sales
            </NuxtLink>
          </li>
          <li
            v-if="!isAuthenticated"
            class="saas-header__nav-item margin-right-2"
          >
            <Button :to="{ name: 'login' }" type="secondary">Login</Button>
          </li>
          <li v-if="!isAuthenticated" class="saas-header__nav-item">
            <Button :to="{ name: 'signup' }">Sign up</Button>
          </li>
          <li v-if="isAuthenticated" class="saas-header__nav-item">
            <Button :to="{ name: 'all-workspaces' }" type="secondary"
              >My dashboard</Button
            >
          </li>
        </ul>
      </nav>
      <a class="saas-header__nav-toggle" @click="showNav()">
        <i class="iconoir-menu"></i>
      </a>
    </header>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRuntimeConfig, useNuxtApp } from '#imports'

import { onClickOutside } from '@baserow/modules/core/utils/dom'
import HeaderSubNavItem from '@saas/components/header/HeaderSubNavItem'
import GithubStarButton from '@saas/components/githubStarButton'

export default {
  name: 'Header',
  components: { GithubStarButton, HeaderSubNavItem },
  setup() {
    const config = useRuntimeConfig()
    const { $store } = useNuxtApp()

    // Safe getter helper that returns empty array if store is not ready
    const safeGetMenuChildPagesPerType = (type) => {
      if (!$store || !$store.hasModule('saasLayout')) return []
      return $store.getters['saasLayout/getMenuChildPagesPerType'](type) || []
    }
    const safeGetMenuPagesPerType = (type) => {
      if (!$store || !$store.hasModule('saasLayout')) return []
      return $store.getters['saasLayout/getMenuPagesPerType'](type) || []
    }

    return {
      publicBackendUrl: config.public.publicBackendUrl,
      store: $store,
      safeGetMenuChildPagesPerType,
      safeGetMenuPagesPerType,
    }
  },
  data() {
    return {
      navVisible: false,
      openSub: null,
      lastSubClickOutsideCancel: null,
      menuOpenSub: [],
    }
  },
  computed: {
    productPages() {
      return this.safeGetMenuChildPagesPerType('saas_cms.ProductListingPage')
    },
    productPagesTwoChunks() {
      return this.splitChunk(this.productPages, 2)
    },
    departmentPages() {
      return this.safeGetMenuChildPagesPerType('saas_cms.DepartmentListingPage')
    },
    departmentPagesTwoChunks() {
      return this.splitChunk(this.departmentPages, 2)
    },
    industryPages() {
      return this.safeGetMenuChildPagesPerType('saas_cms.IndustryListingPage')
    },
    industryPagesTwoChunks() {
      return this.splitChunk(this.industryPages, 2)
    },
    communityPages() {
      return this.safeGetMenuPagesPerType('saas_cms.CommunityPage')
    },
    integrationPages() {
      return this.safeGetMenuPagesPerType('saas_cms.IntegrationsPage')
    },
    navOpen() {
      if (!this.store || !this.store.hasModule('header')) return false
      return this.store.getters['header/getNavOpen']
    },
    topBars() {
      if (!this.store || !this.store.hasModule('header')) return []
      return this.store.getters['header/getTopBars'] || []
    },
    isAuthenticated() {
      if (!this.store || !this.store.hasModule('auth')) return false
      return this.store.getters['auth/isAuthenticated']
    },
    numberOfJobs() {
      if (!this.store || !this.store.hasModule('saasLayout')) return 0
      return this.store.getters['saasLayout/getNumberOfJobs'] || 0
    },
  },
  watch: {
    $route(value) {
      this.hideNav()
      this.hideSub()
    },
  },
  methods: {
    toggleSub(event, targetElement) {
      event.stopPropagation()

      if (this.lastSubClickOutsideCancel !== null) {
        this.lastSubClickOutsideCancel()
        this.lastSubClickOutsideCancel = null
      }

      if (this.openSub === targetElement) {
        this.openSub = null
        return
      }

      this.openSub = targetElement
      this.lastSubClickOutsideCancel = onClickOutside(targetElement, () => {
        this.toggleSub(event, targetElement)
      })
    },
    hideSub() {
      if (this.lastSubClickOutsideCancel !== null) {
        this.lastSubClickOutsideCancel()
        this.lastSubClickOutsideCancel = null
      }

      this.openSub = null
    },
    toggleMenuSub(event, targetElement) {
      const index = this.menuOpenSub.findIndex((e) => e === targetElement)
      if (index < 0) {
        this.menuOpenSub.push(targetElement)
      } else {
        this.menuOpenSub.splice(index, 1)
      }
    },
    inMenuSub(targetElement) {
      return this.menuOpenSub.includes(targetElement)
    },
    showNav() {
      if (this.store && this.store.hasModule('header')) {
        this.store.dispatch('header/setNavOpen', true)
      }
    },
    hideNav() {
      if (this.store && this.store.hasModule('header')) {
        this.store.dispatch('header/setNavOpen', false)
      }
    },
    /**
     * Split an array into `size` number of chunks. This can be used to spread items
     * over two columns.
     */
    splitChunk(array, size = 2) {
      const response = []
      for (let i = 0; i < size; i++) {
        response.push([])
      }
      for (let i = 0; i < array.length; i++) {
        response[i % size].push(array[i])
      }
      return response
    },
  },
}
</script>
